import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import { LogControllerDtoSpecialBoxLogListRequest, PerplayLogApi } from '../../models/src';
import {
  setSpecialBoxLogPagination,
  setTotalCount,
  specialBoxLogList,
} from '../../actions/log/specialBoxLogActions';
import { SPECIALBOXLOG_LIST_REQUEST } from '../../constants/log/specialBoxLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoSpecialBoxLogListResponse
  from '../../models/src/model/LogControllerDtoSpecialBoxLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* specialBoxLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoSpecialBoxLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.specialBoxNo = payload.specialBoxNo;
    requestData.playedGameSessionNo = payload.playedGameSessionNo;
    requestData.openTransactionNo = payload.openTransactionNo;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogSpecialBoxLogListPost({ logControllerDtoSpecialBoxLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoSpecialBoxLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    yield put(specialBoxLogList(data.list));
    yield put(setTotalCount(data.totalCount));
    yield put(setSpecialBoxLogPagination(
      payload.page,
      data.totalCount,
      payload.beginDate,
      payload.endDate,
      payload.searchCode,
      payload.searchString,
    ));
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* specialBoxLogRootSaga() {
  yield all([
    takeEvery(SPECIALBOXLOG_LIST_REQUEST, specialBoxLogListRequestSaga),
  ]);
}

const specialBoxLogSagas = [fork(specialBoxLogRootSaga)];

export default specialBoxLogSagas;
